import {
  RETURN_URL_KEY,
  RETURN_URL_ATTEMPTS_KEY,
} from '../useReturnUrl.constants';

export const storeReturnUrl = (url: string): void => {
  try {
    localStorage.setItem(RETURN_URL_KEY, url);
  } catch (error) {
    console.error('Error storing return URL:', error);
  }
};

export const getStoredReturnUrl = (): string | null => {
  try {
    return localStorage.getItem(RETURN_URL_KEY);
  } catch (error) {
    console.error('Error retrieving return URL:', error);
    return null;
  }
};

export const getRedirectAttempts = (): number => {
  try {
    const attempts = localStorage.getItem(RETURN_URL_ATTEMPTS_KEY);
    return parseInt(attempts || '0', 10);
  } catch (error) {
    console.error('Error retrieving redirect attempts:', error);
    return 0;
  }
};

export const incrementRedirectAttempts = (currentAttempts: number): number => {
  try {
    const newAttempts = currentAttempts + 1;
    localStorage.setItem(RETURN_URL_ATTEMPTS_KEY, String(newAttempts));
    return newAttempts;
  } catch (error) {
    console.error('Error incrementing redirect attempts:', error);
    return currentAttempts;
  }
};

export const clearReturnUrlData = (): void => {
  try {
    localStorage.removeItem(RETURN_URL_KEY);
    localStorage.removeItem(RETURN_URL_ATTEMPTS_KEY);
  } catch (error) {
    console.error('Error clearing return URL data:', error);
  }
};

export const clearOnlyReturnUrl = (): void => {
  try {
    localStorage.removeItem(RETURN_URL_KEY);
  } catch (error) {
    console.error('Error clearing return URL:', error);
  }
};

export const clearRedirectAttempts = (): void => {
  try {
    localStorage.removeItem(RETURN_URL_ATTEMPTS_KEY);
  } catch (error) {
    console.error('Error clearing redirect attempts:', error);
  }
};
